import { Flex, Slider as NativeBaseSlider } from 'native-base';
import React, { useEffect, useState } from 'react';

import { Text } from '~/components/text';

export type SliderProps = {
    minValue: number;
    maxValue: number;
    initialValue: number;
    minValueDescription: string;
    maxValueDescription: string;
    onChange: (newValue: number) => void;
};

export const Slider = (props: SliderProps) => {
    const { minValue, maxValue, initialValue, minValueDescription, maxValueDescription, onChange } = props;
    const [currentValue, setCurrentValue] = useState<number>(initialValue);

    useEffect(() => {
        setCurrentValue(initialValue);
    }, [initialValue]);

    const handleChange = (newValue: number) => {
        setCurrentValue(newValue);
        onChange(newValue);
    };

    return (
        <Flex direction="column">
            <Flex direction="row" justifyContent="space-between" alignItems="flex-end" mb="2">
                <Flex basis="0" grow="1">
                    <Text.INPUT_FIELD_TITLE>{minValueDescription}</Text.INPUT_FIELD_TITLE>
                </Flex>
                <Flex basis="0" grow="1" direction="column" alignItems="flex-end">
                    <Text.INPUT_FIELD_TITLE>{maxValueDescription}</Text.INPUT_FIELD_TITLE>
                </Flex>
            </Flex>
            <NativeBaseSlider
                minValue={minValue}
                maxValue={maxValue}
                defaultValue={initialValue}
                onChange={handleChange}
                accessibilityValue={{ min: minValue, max: maxValue, now: currentValue }}
                colorScheme="primaryDefault"
            >
                <NativeBaseSlider.Track>
                    <NativeBaseSlider.FilledTrack />
                </NativeBaseSlider.Track>
                <NativeBaseSlider.Thumb />
            </NativeBaseSlider>
        </Flex>
    );
};
